'use strict';

var KayleeBase = require('./KayleeBase');
var KayleeConnectionState = require('./KayleeConnectionState');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeControllerAuth');

var KayleeControllerAuth = {
    signIn: signIn,
};

var authInProgress = false;

function signIn(authInfo) {
    var err;

    if (authInProgress) {
        err = new Error('authentication request already in progress');
        log.error(err.message);
        return Promise.reject(err);
    }

    if (Object.keys(authInfo).length !== 9 ||
        !authInfo.hasOwnProperty('secret') ||
        !authInfo.hasOwnProperty('model') ||
        !authInfo.hasOwnProperty('serialNumber') ||
        !authInfo.hasOwnProperty('platform') ||
        !authInfo.hasOwnProperty('platformVersion') ||
        !authInfo.hasOwnProperty('uuid') ||
        !authInfo.hasOwnProperty('appName') ||
        !authInfo.hasOwnProperty('appVersionCode') ||
        !authInfo.hasOwnProperty('kayleeVersion')) {
        err = new Error('auth info has missing or invalid properties');
        log.error(err.message);
        return Promise.reject(err);
    }

    authInProgress = true;
    authInfo = JSON.parse(JSON.stringify(authInfo));
    authInfo.time = Date.now();

    return signInAnonymously({ authInfo: authInfo })
    .then(requestAuth)
    .then(signInWithToken)
    .then(function() { authInProgress = false; })
    .catch(function(err) {
        authInProgress = false;
        return Promise.reject(err);
    });
}

function getRandomString(length) {
    // Modeled after base64 web-safe chars, but ordered by ASCII. This is
    // also the same character set used to generate Firebase keys.
    var chars = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    var randomChars = [];

    for (var i = 0; i < length; i++) {
        var n = Math.random() * chars.length;
        randomChars.push(chars[Math.floor(Math.random() * (n - 1))]);
    }

    return randomChars.join('');
}

function signInAnonymously(obj) {
    obj.uid = getRandomString(128);
    return KayleeBase.app.auth().signOut()
    .then(function() {
        return obj;
    });
}

function requestAuth(obj) {
    if (!KayleeConnectionState.isConnected()) {
        var err = new Error('database not connected');
        log.error(err.message);
        return Promise.reject(err);
    }
    return Promise.race([
        KayleeUtil.timeout('timeout', 10000),
        KayleeBase.request('authRequest', obj.authInfo),
    ])
    .then(function(result) {
        if (result === 'timeout') {
            var err = new Error('authentication timeout');
            log.error(err.message);
            return Promise.reject(err);
        }

        obj.token = result;
        return obj;
    });
}

function signInWithToken(obj) {
    if (!obj.hasOwnProperty('tokenRetries')) {
        obj.tokenRetries = 0;
    }

    return KayleeBase.app.auth().signInWithCustomToken(obj.token)
    .then(function(fbUser) {
        return fbUser;
    }, function(err) {
        if (obj.tokenRetries >= 2 ||
            err.code === 'auth/custom-token-mismatch' ||
            err.code === 'auth/invalid-custom-token') {
            return Promise.reject(err);
        }

        log.warning('token authentication failed with error: ' + JSON.stringify(err, null, 4));
        log.warning('retrying authentication, attempt: ' + (obj.tokenRetries + 2));
        obj.tokenRetries++;
        return signInWithToken(obj);
    });
}

module.exports = KayleeControllerAuth;
